import { render, staticRenderFns } from "./AddOtherInfo.vue?vue&type=template&id=ca95430c&scoped=true&"
import script from "./AddOtherInfo.vue?vue&type=script&lang=js&"
export * from "./AddOtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddOtherInfo.vue?vue&type=style&index=0&id=ca95430c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca95430c",
  null
  
)

export default component.exports